package features.schedule.domain

data class Schedule(
    val month: Int,
    val year: Int,
    val assignments: MutableMap<String, MutableMap<Int, String>> = mutableMapOf()
)
